import InfiniteScroll from 'react-infinite-scroller';
import { useLocalStorage } from 'usehooks-ts';

import { useAdsInfinite } from '@/lib/hooks/useInfiniteAdsList';
import AdCard, { AdCardLayout } from '@/tayara-kit/ListingItemCard/AdCard';
import { AdType } from '@/tayara-kit/ListingItemCard/types';
import Text from '@/tayara-kit/Text';

import { IListingItem, IUserData } from '../types';

export interface ShopListingsProps {
  adsByShop: IListingItem[];
  countAdByShop: number;
  shopData: IUserData;
}

const ShopListings = ({
  adsByShop,
  countAdByShop,
  shopData,
}: ShopListingsProps) => {
  const [adsListData, , loadMoreAdsList] = useAdsInfinite({
    userId: shopData.kcid || '',
    isPublic: true,
    initialAdslistData: adsByShop,
    initialCountTotalAds: countAdByShop,
  });

  const [layout] = useLocalStorage('AdCardLayout', AdCardLayout.Fixed);

  return (
    <div className="mx-1 my-10">
      <div className="space-x-1 my-6 flex justify-center items-center lg:justify-start">
        <Text text="Annonces" className="text-gray-700 font-bold text-2xl" />
        <Text
          text={`(${countAdByShop} annonces actives)`}
          className="block  mt-1 text-sm lg:text-base font-bold text-info"
        />
      </div>
      <InfiniteScroll
        pageStart={0}
        loadMore={loadMoreAdsList}
        initialLoad={false}
        hasMore={true}
        loader={<div className="loader" key={0}></div>}
        threshold={5000}
      >
        <div className="w-full flex flex-wrap gap-x-2 md:gap-x-6 lg:gap-x-5 xl:gap-x-4 gap-y-6  justify-center md:justify-center lg:justify-center xl:justify-center">
          {adsListData.map((item) =>
            item.metadata?.publisher?.id === shopData.kcid ? (
              <a key={item.id}>
                <AdCard
                  adType={AdType.Normal}
                  key={item.id}
                  adCardData={
                    {
                      ...item,
                      metadata: {
                        ...item.metadata,
                        publisher: {
                          ...item.metadata?.publisher,
                          name: shopData.fullname,
                        },
                      },
                    } as IListingItem
                  }
                  layout={layout || undefined}
                />
              </a>
            ) : null
          )}
        </div>
      </InfiniteScroll>
    </div>
  );
};

export default ShopListings;
